// src/components/claims/StatusChip.jsx
// A claim status in our words, coloured by its tone (claimsModel.STATUS_TONE).
// ⛔ Never «Verificato»: SUPPORTED means the quote was found in the source.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATUS_TONE } from './claimsModel.js';
import { RADII, SEMANTIC } from '../../constants/theme.js';

export default function StatusChip({ status, count }) {
  const { t: tr } = useTranslation('outputs');
  const palette = SEMANTIC[STATUS_TONE[status] || 'neutro'];
  const label = tr(`claims.status.${status}`, { defaultValue: status });
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap',
      padding: '2px 8px', borderRadius: RADII.pill, fontSize: '11px', fontWeight: 600,
      background: palette.bg, color: palette.fg,
    }}>
      {label}{count != null ? ` · ${count}` : ''}
    </span>
  );
}
